/** list page query param: open the sync prompt for this template right after it was saved */
export const SYNC_TEMPLATE_ID_QUERY_PARAM = 'syncTemplateId'

/** editor query param: rebuild the route line on open, after a stop of the template was moved */
export const REBUILD_ROUTE_QUERY_PARAM = 'rebuildRoute'

/**
 * the stop whose usage window to come back to: carried through the template editor opened from it,
 * then opens that window on the stop templates page once the template is saved
 */
export const USAGE_STOP_ID_QUERY_PARAM = 'usageStopId'

export const TONE_SYNC_OUTCOME = {
	READY: 'ok',
	UPDATED: 'ok',
	DIVERGED: 'warn',
	TOO_LATE: 'fail',
	TASKS_ON_REMOVED_STOP: 'fail',
	DEVICE_BUSY: 'fail',
	INVALID: 'fail',
	NOT_FOUND: 'fail',
} as const
